// components/ContactForm.js
import { useState } from "react";
import axios from "axios";
import Cookies from 'js-cookie';

function ContactForm({ onSuccess = null }) {
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState(""); // Optional
  const [phone, setPhone] = useState(""); // Required
  const [message, setMessage] = useState(""); // Required
  const [error, setError] = useState(""); // For error handling

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!name) {
      setError("Please enter your name.");
      return;
    }
    if (!phone) {
      setError("Please enter your phone number.");
      return;
    }
    if (!message) {
      setError("Please enter your message.");
      return;
    }

    setIsLoading(true);

    const data = new FormData();
    data.append("name", name);
    data.append("email", email);
    data.append("phone", phone);
    data.append("message", message);

    try {
      const response = await axios.post("/pro/contact-us.php", data);
      if (response.data.success) {
        alert("Your message has been sent successfully!");
        Cookies.set("popup_shown", "true", { expires: 3650 });
        if (onSuccess) onSuccess(); // close the popup
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      alert("Error occurred! Please try again later.");
      console.error(error);
    }

    setIsLoading(false);
  };

  return (
    <div className="border-0 rounded login-content">
      <div className="login-form py-1" style={{ opacity: 0.9 }}>
        <h4 style={{ fontSize: '22px', color: '#1D2630', marginTop: "30px", letterSpacing: '1.4px' }} className="font-bold main-heading-style mb-3">Contact Us</h4>

        {error && <div className="alert alert-danger">{error}</div>}

        <div className="form-group col-12">
          <label className="font-size-12"><i className="fas fa-user mr-2"></i>Name</label>
          <div className="input-group border rounded">
            <input
              type="text"
              placeholder="Your Name"
              className="form-control custom-placeholder"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
        </div>

        <div className="form-group col-12">
          <label className="font-size-12"><i className="fas fa-phone mr-2"></i>Phone No</label>
          <div className="input-group border rounded">
            <div className="input-group-prepend">
              <span className="input-group-text">+92</span>
            </div>
            <input
              type="text"
              placeholder="Phone No"
              className="form-control custom-placeholder"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
        </div>

        <div className="form-group col-12">
          <label className="font-size-12"><i className="fas fa-envelope mr-2"></i>Email (Optional)</label>
          <div className="input-group border rounded">
            <input
              type="email"
              placeholder="Your Email"
              className="form-control custom-placeholder"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>

        <div className="form-group col-12">
          <label className="font-size-12"><i className="fas fa-comment-dots mr-2"></i>Message</label>
          <div className="input-group border rounded">
            <textarea
              className="form-control custom-placeholder"
              placeholder="Your Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </div>
        </div>

        <div className="form-group col-12">
          <button
            onClick={handleSubmit}
            className="btn btn-flat m-b-30 m-t-30 mx-auto"
            style={{
              borderRadius: '30px',
              backgroundColor: '#2C99A1',
              border: '2px solid #2C99A1',
              color: 'white',
            }}
            disabled={isLoading}
          >
            {isLoading ? (
              <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Please Wait...</>
            ) : (
              "Send Message"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ContactForm;
